function hoursToOffset(hours) {
  const sign = hours >= 0 ? "+" : "-";
  const absHours = Math.abs(hours);

  const pad = (num) => num.toString().padStart(2, "0");

  return `${sign}${pad(absHours)}:00`;
}

Object.defineProperty(Event.prototype, "timezone", {
  get() {
    const offset = -(new Date().getTimezoneOffset() / 60);
    return this.target.value + hoursToOffset(offset);
  }
});


/*
 * <time-zone />
 * Gives a string representation of the navigator's timezone like "europe/paris".
 */
class TimeZone extends HTMLElement {
  constructor() {
    super();
    const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.attachShadow({ mode: "open" });
    this.shadowRoot.innerHTML = timeZone;
  }
}

customElements.define("time-zone", TimeZone);
